import Dashboard from "./app/Dashboard/Index";

// Master Components
import CategoryMaster from "./app/Masters/Category/Index";
import SubCategoryMaster from "./app/Masters/SubCategory/Index";
import ProductCategoryMaster from "./app/Masters/ProductCategory/Index";

// Product Components
import ProductDetail from "./app/ProductDetail/Index";
import ProductManageImages from "./app/ProductDetail/ManageImages/Index";

// Offer Components
import OfferDetail from "./app/OfferDetail/Index";

// Order Componets
import OrderDetail from "./app/OrderDetail/Index";
import ProductSlip from "./app/ProductSlip/Index";

// Coupon Component
import CouponDetail from "./app/CouponDetail/Index";

// User Component
import UserMgmt from "./app/UserMgmt/Index";

import DeliveryCharges from "./app/DeliveryCharges/Index";

import Invoice from "./app/SampleInvoices";

// auth components
import Login from "./app/Auth/Login/Index";

// Error
import Error403 from "app/Error/Error403";
import Error404 from "app/Error/Error404";

const routes = [
  { path: "/dashboard", component: Dashboard },

  { path: "/category", component: CategoryMaster },
  { path: "/subcategory", component: SubCategoryMaster },
  { path: "/productcategory", component: ProductCategoryMaster },

  { path: "/product", component: ProductDetail },
  { path: "/product/:id", component: ProductManageImages },

  { path: "/offer", component: OfferDetail },

  { path: "/order", component: OrderDetail },
  { path: "/slip", component: ProductSlip },

  { path: "/user", component: UserMgmt },

  { path: "/deliverycharges", component: DeliveryCharges },

  { path: "/coupon", component: CouponDetail },

  { path: "/sample/*", component: Invoice, ispublic: true },

  { path: "/login", component: Login, ispublic: true },
  { path: "/", component: Login, ispublic: true },

  { path: "/403", component: Error403, ispublic: true },

  { path: "*", component: Error404, ispublic: true }, // For 404 error page
];

export default routes;
